module.exports = __webpack_public_path__ + "11bf893b0951a502ff9d908b011966f3.jpg";